import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const AuthLayout = ({ children }) => {
  const location = useLocation();
  const isLogin = location.pathname === '/app/login';

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-950 via-blue-950 to-slate-900 flex items-center justify-center p-4 pt-[calc(env(safe-area-inset-top)+1rem)]">
      {/* Background Effects */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute -top-1/2 -left-1/2 w-full h-full bg-cyan-500/10 rounded-full blur-3xl"></div>
        <div className="absolute -bottom-1/2 -right-1/2 w-full h-full bg-blue-600/10 rounded-full blur-3xl"></div>
      </div>
      
      <div className="relative w-full max-w-md">
        {/* Logo and Title */}
        <div className="text-center mb-8">
          <div className="flex justify-center mb-6">
            <div className="relative">
              <div className="absolute inset-0 bg-gradient-to-r from-cyan-500 to-blue-600 rounded-2xl blur-lg opacity-50"></div>
              <img 
                src="/logo.jfif" 
                alt="Revolution" 
                className="relative w-24 h-24 rounded-2xl object-cover border-2 border-white/20 shadow-xl"
              />
            </div>
          </div>
          <h1 className="text-4xl font-bold text-white mb-3">
            Revolution
          </h1>
        </div>

        {/* Main Card */}
        <div className="bg-gradient-to-br from-slate-900/90 to-slate-800/90 backdrop-blur-xl rounded-3xl shadow-2xl border border-white/10 p-8">
          {children}
        </div>

        {/* Footer Navigation */}
        <div className="mt-8 text-center">
          <div className="flex justify-center space-x-6">
            <Link 
              to="/app/login" 
              className={`flex items-center space-x-2 px-4 py-2 rounded-xl transition-all duration-200 ${
                isLogin 
                  ? 'bg-cyan-500/20 text-cyan-400 border border-cyan-500/30' 
                  : 'text-gray-400 hover:text-cyan-400 hover:bg-cyan-500/10 border border-transparent'
              }`}
            >
              <span>🚀</span>
              <span className="font-medium">Entrar</span>
            </Link>
            <Link 
              to="/app/register" 
              className={`flex items-center space-x-2 px-4 py-2 rounded-xl transition-all duration-200 ${
                !isLogin 
                  ? 'bg-blue-500/20 text-blue-400 border border-blue-500/30' 
                  : 'text-gray-400 hover:text-blue-400 hover:bg-blue-500/10 border border-transparent'
              }`}
            >
              <span>✨</span>
              <span className="font-medium">Recrutamento</span>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;